<template>
	<div>
		<div class="upper_div"></div>
		<div class="bgImg" data-font-size="10" data-font-size-type="px">
			<div class="formBox" data-font-size="10" data-font-size-type="px">
				<div
					class="titleContainer"
					data-font-size="10"
					data-font-size-type="px"
				>
					<h1 class="title" data-font-size="35" data-font-size-type="px">
						אתר הנדל"ן הממשלתי – שינוי סיסמה
					</h1>
					<p
						class="plainText"
						data-font-size="14"
						data-font-size-type="px"
						data-line-height="21.98px"
					>
						בחר סיסמה חדשה
					</p>
				</div>
				<div v-if="passwordChanged == false" class="formContainer">
					<div
						class="inputContainer"
						data-font-size="10"
						data-font-size-type="px"
					>
						<input
							v-model="newPassword"
							name="password"
							class="genericInput"
							type="password"
							autocomplete="on"
							maxlength="20"
							placeholder="בחרו סיסמה המתאימה להגדרות"
							value=""
						/><button class="editBtn"></button>
						<button class="infoBtn" type="button">
							<div
								class="iconCircle"
								data-font-size="10"
								data-font-size-type="px"
							>
								?
							</div>
						</button>
					</div>
					<div
						class="inputContainer"
						data-font-size="10"
						data-font-size-type="px"
					>
						<input
							v-model="newPasswordAgain"
							name="passwordAgain"
							class="genericInput"
							type="password"
							autocomplete="on"
							maxlength="20"
							placeholder="הזן את הסיסמה בשנית"
							value=""
						/><button class="editBtn"></button>
					</div>
					<button @click="resetPassword()" class="btn blue" type="submit">
						שינוי סיסמה
					</button>
					<div style="text-align: center; height: 22px">
						<p style="color: red" class="plainText">{{ errorText }}</p>
					</div>
				</div>
				<div v-else class="formContainer">
					<div
						class="inputContainer"
						data-font-size="10"
						data-font-size-type="px"
					>
						<h1 class="title">סיסמא עודכנה בהצלחה!</h1>
					</div>
					<button @click="gotToLogin()" class="btn blue" type="submit">
						אישור
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			email: "",
			newPassword: "",
			newPasswordAgain: "",
			verifyToken: "",
			passwordChanged: false,
			errorText: "",
		};
	},
	methods: {
		gotToLogin() {
			var appVue = this;
			appVue.mixin_goTo(appVue, "login");
		},
		resetPassword() {
			var appVue = this;
			// check if passwords match
			if (this.newPassword != this.newPasswordAgain) {
				//alert("הסיסמאות אינן תואמות");
				this.errorText = "הסיסמאות אינן תואמות";
				return;
			}
			appVue
				.mixin_resetPassword(
					appVue,
					this.verifyToken,
					this.email,
					this.newPassword,
				)
				.then((user_res) => {
					if (user_res.statusCode == 200) {
						if (user_res.data.message == "סיסמה עודכנה בהצלחה") {
							this.passwordChanged = true;
							appVue.mixin_goTo(appVue, 'login');
						}
					} 
					else if (user_res.statusCode == 400 || user_res.statusCode == 429) {
						this.errorText = user_res.data.message;
					}
					else {
						//alert("שגיאה בשינוי סיסמה");
						this.errorText = "שגיאה בשינוי סיסמה";
					}
				});
		},
	},
	mounted() {
		
		var appVue = this;
		if (appVue.$store.state.verifyToken == null) {
			appVue.$store.state.verifyToken = sessionStorage.verifyToken;
		}
		this.verifyToken = appVue.$store.state.verifyToken;
		
		if (appVue.$store.state.useremail == null) {
			appVue.$store.state.useremail = this.mixin_getCookie('useremail');
		}
		this.email = appVue.$store.state.useremail;
		
		
	},
};
</script>

<style></style>
